import React from 'react';
import Row from '@airasia-common/react-dom/components/Container/Row';
import ActivityIndicator from '@airasia-common/react-dom/components/ActivityIndicator';

const LoadingComponents = () => (
  <Row margin={64} justifyContent="center">
    <ActivityIndicator />
  </Row>
);

export default LoadingComponents;
